import React from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/hu";

interface MyLeaveCalendarPathFillPriorProps {
  color: string;
}

export const MyLeaveCalendarPathFillPrior: React.FC<MyLeaveCalendarPathFillPriorProps> = ({ color }) => {
  return (
    <path
      id="path74"
      fill={color}
      d="M 16.041827,0.00593567 15.634804,0 c -1.338387,-0.01951788 -2.617475,0.457399 -3.53312,1.2636 l -10.7904334,9.5 c -1.74785584,1.5388 -1.74785584,3.934 0,5.4728 l 10.7904334,9.5 c 0.915645,0.8062 2.211928,1.219105 3.536584,1.243046 l 0.405097,0.0073 z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
  );
};

export default MyLeaveCalendarPathFillPrior;
